// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rPVK9zQCa3Yhd047jkZz .modal-content{background:#fff;color:#333}.Xp9VLsd_cfmUfsdRs7Mb{padding:2rem;text-align:center}.PpNgFxtJcYi0HxwdE7ug{font-size:1.5rem;font-weight:700;margin-bottom:1rem}.ePr2pmqGK1CLqtqyi2D6{margin-bottom:2rem;text-align:center;line-height:1.5}.ML16a8MzQqdNUwfgqAvq{font-weight:700}.G61BeCxf9hqUacEtb6Nm{display:flex;justify-content:center;gap:1rem}.G61BeCxf9hqUacEtb6Nm .button{margin-left:.5rem}.ocdLqItCU2hrxBhJtwd0{display:inline-block;width:1em;height:1em;border:2px solid currentColor;border-top-color:rgba(0,0,0,0);border-radius:50%;animation:toM43OPyYl_z23pJu_5d .8s linear infinite;margin-right:.625rem;vertical-align:middle}@keyframes toM43OPyYl_z23pJu_5d{to{transform:rotate(360deg)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalReview": "rPVK9zQCa3Yhd047jkZz",
	"confirmationContainer": "Xp9VLsd_cfmUfsdRs7Mb",
	"confirmationTitle": "PpNgFxtJcYi0HxwdE7ug",
	"confirmationText": "ePr2pmqGK1CLqtqyi2D6",
	"boldParagraph": "ML16a8MzQqdNUwfgqAvq",
	"confirmationButtonsContainer": "G61BeCxf9hqUacEtb6Nm",
	"iconSpinner": "ocdLqItCU2hrxBhJtwd0",
	"spin": "toM43OPyYl_z23pJu_5d"
};
export default ___CSS_LOADER_EXPORT___;
